import { cn } from "utils/cn";

export const BotActions: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"div">
> = (props) => (
  <div
    {...props}
    className={cn("mb-0.5 mt-2.5 flex items-center gap-5", props.className)}
  />
);
